var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabIsFunLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lab-is-Fun-Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 362,
    height: 362,
    viewBox: "0 0 362 362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    transform: "translate(0 -1.785)",
    fill: "#045b62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 360.7929077148438 363.28515625 L 0.5 363.28515625 L 0.5 2.992231845855713 L 360.7929077148438 363.28515625 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 4.199310302734375 L 1 362.78515625 L 359.5858154296875 362.78515625 L 1 4.199310302734375 M 0 1.785125732421875 L 362 363.78515625 L 0 363.78515625 L 0 1.785125732421875 Z",
    stroke: "none",
    fill: "#045b62"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_4",
    "data-name": "\\uD0C0\\uC6D0 4",
    transform: "translate(253 109)",
    fill: "#045b62",
    stroke: "#045b62",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 54.5,
    r: 54.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 54.5,
    r: 54,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_3",
    "data-name": "\\uD0C0\\uC6D0 3",
    transform: "translate(144)",
    fill: "#045b62",
    stroke: "#045b62",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 54.5,
    r: 54.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 54.5,
    r: 54,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabIsFunLogo);
export default __webpack_public_path__ + "static/media/Lab-is-Fun-Logo.5990d37a23b049f1636ed4c4afee8053.svg";
export { ForwardRef as ReactComponent };